<template>
    <div id="manageClass">
        <div class="allBodyDiv">
            <div style="margin-top: 15px">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{path:'/storetestrecord'}">自测列表</el-breadcrumb-item>
                    <el-breadcrumb-item>{{testName}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card ">
                        <div slot="header" class="clearfix">
                            <i class="blueI" style="left: 10px"></i>


                            <div style="display:inline-block">
                                <span class="cardHeader">{{$route.query.name}}</span>
                                <span style="font-size: 12px;color: #7d7d7d">共进行{{testLength}}次考试</span>
                            </div>

                            <div class="fr" style="margin-right: 41%">
                                <el-radio-group v-model="radio3" @change="getData()">
                                    <el-radio-button :label="1">综合统计</el-radio-button>
                                    <el-radio-button :label="2">单次统计</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div style="margin-top:30px; ">
                            <div style="position:relative">
                                <div>
                                    <div v-if="radio3==1">
                                        <div style="position:absolute">
                                            <span><img src="/static/images/exam/quxian.png" alt="" align="top"></span>
                                            分数曲线
                                        </div>
                                        <!--<el-date-picker-->
                                                <!--class="fr nbTimePacker"-->
                                                <!--style="position: absolute;top:-9px;right: 0;z-index: 99;"-->
                                                <!--v-model="timeValue"-->
                                                <!--type="daterange"-->
                                                <!--start-placeholder="开始日期"-->
                                                <!--end-placeholder="结束日期"-->
                                                <!--@change="getData"-->
                                                <!--default-value="2010/10/01">-->
                                        <!--</el-date-picker>-->
                                        <ve-line  id="canvas" :data="chartData" :settings="chartSettings"></ve-line>
                                    </div>

                                    <div v-else style="margin-bottom: 20px;">
                                        <div>
                                            <el-row style="padding-bottom:10px;border-bottom:1px solid #ebedf3">
                                                <div
                                                        v-for="i in listData"
                                                        :key="i.id"
                                                        style="margin-bottom: 10px"
                                                        :class="{testCard:true, activeTest:i.active}"
                                                        @click="getOneTestInfo(i.id)">
                                                    <div>{{i.score}}分</div>
                                                    <span style="font-size: 12px;">{{i.addtimeStr}}</span>
                                                </div>
                                            </el-row>
                                        </div>
                                        <div v-for="i in listData" :key="i.id">
                                            <span v-if="i.active" style="float: right;color: #d8d8d8;font-size: 12px;">
                                                本次考试用时
                                                {{i.timelength}}
                                            </span>
                                        </div>
                                        <el-row style="margin-top:35px;">
                                            <div style="height:25px;line-height:16px;margin-bottom: 15px;">
                                                <span><img src="/static/images/exam/dianpin.png" alt="" align="top"></span>
                                                实验点评
                                            </div>
                                            <div class="testDetails">
                                                <div v-if="oneData.comments&&oneData.comments.length>0" style="color:#f76252">在操作顺序方面，需要注意以下几点</div>

                                                <div v-for="(index,i) in oneData.comments" :key="i.id" style="padding-left:10px;">
                                                    {{i+1}}.&nbsp;{{index}}
                                                </div>

                                                <div style="color:#f76252">在操作及数据处理上，需要注意以下几点</div>
                                                <div v-for="(index,i) in oneData.step_comment" :key="i.id" style="padding-left:10px;">
                                                    {{i+1}}.&nbsp;{{index}}
                                                </div>
                                            </div>
                                        </el-row>
                                    </div>
                                </div>

                                <div style="height:25px;line-height:25px;margin-bottom: 15px;">
                                    <span><img src="/static/images/exam/defen.png" alt="" align="top"></span>
                                    得分细则
                                </div>

                                <div v-if="radio3==1" >
                                    <div class="tableDataHeader">
                                        <div style="width: 439px">实验步骤</div>
                                        <div style="width: 437px">实验操作</div>
                                        <div style="width: 119px">错误次数</div>
                                        <div style="width: 119px;border-right:none">错误类型</div>
                                    </div>
                                    <div class="scoreRuleTable">
                                        <div v-for="i in data" :key="i.id">
                                            <div class="dataTitle">{{i.step_name}}</div>
                                            <div class="dataList">
                                                <div class="dataBody" v-for="a in i.item" :key="a.id">
                                                    <div class="stepName">{{a.step_name}}</div>
                                                    <div class="frozen" :style="{color:a.error_num<=0?'':'red', width: '120px'}">{{a.error_num}}</div>
                                                    <div class="errorInfo">
                                                        <template v-for="c in a.errorInfo">
                                                            <div class="frozen" :key="c.id" v-if="c.error_num > 0">
                                                                <span>
                                                                    <img v-if="c.name.indexOf('数据')!=-1" src="/static/images/exam/data.png" width="14px" alt="">
                                                                    <img v-else-if="c.name.indexOf('操作')!=-1" src="/static/images/exam/operate.png" width="14px" alt="">
                                                                    <img v-else-if="c.name.indexOf('顺序')!=-1" src="/static/images/exam/order.png" width="14px" alt="">
                                                                    {{c.name}}
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else >
                                    <div class="tableDataHeader">
                                        <div style="width: 439px">实验步骤</div>
                                        <div style="width: 437px">实验操作</div>
                                        <div style="width: 119px">评分</div>
                                      <div style="width: 159px;border-right:none">错误类型</div>
                                    </div>
                                    <div class="scoreRuleTable">
                                        <div v-for="i in oneData.steps" :key="i.id">
                                            <div class="dataTitle">{{i.step_name}}</div>
                                            <div class="dataList">
                                                <div class="dataBody" v-for="a in i.itemStep" :key="a.id">
                                                    <div class="stepName">{{a.step_name}}</div>
                                                    <div class="score" :style="{color:a.error_num<=60&&a.error_num?'red':''}">{{a.score?a.score:0}}</div>
                                                    <div class="errorInfo">
                                                        <div style="width:160px;text-align:center;flex-grow: 0;">
                                                            <span v-if="a.error">
                                                                <img v-if="a.error.indexOf('数据')!=-1" src="/static/images/exam/data.png" width="14px" alt="">
                                                            <img v-else-if="a.error.indexOf('操作')!=-1" src="/static/images/exam/operate.png" width="14px" alt="">
                                                            <img v-else-if="a.error.indexOf('顺序')!=-1" src="/static/images/exam/order.png" width="14px" alt="">
                                                                <span v-else></span>
                                                            </span>
                                                            <span v-else></span>
                                                            {{a.error}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import{
      oneInfo,
        gettestrecord
    }from'./../../api/exam_api'
    export default {
        data() {
            return{
                tableData2:[],
                currentPage4:1,
                radio3:1,
                chartData:{
                    columns: ['counttime', 'countnum'],
                    rows: []
                },
                chartSettings : {
                    labelMap: {
                        countnum: '得分'
                    }
                },
                timeValue:[],
                data:{},
                testName:'',
                listData:[],
                testId:'',
                stepData:[],
              courseId:'',
              oneData:{},//新的单次统计数据
              oneStepData:{},//新的单次错误统计
              testLength:{},//新的单次统计数据
            }
        },
        methods:{
            pageSizeChange(){},
            pageChange(){},
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex %3 === 0) {
                        return {
                            rowspan: 3,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            getData($typr){
                this.data=[];
                this.stepData=[];
                let data2={};
              data2 = [{"col":'course_id',"op":"=","val":this.courseId}];
              let str = '?'
              for(let i=0;i<data2.length;i++){
                str += `sp[${i}][col]=${data2[i]["col"]}&sp[${i}][op]=${data2[i]["op"]}&sp[${i}][val]=${data2[i]["val"]}`
              }
                gettestrecord(str,{}).then((res)=>{
                    this.chartData.rows=[];
                    if(res.code==200){
                      this.testLength = res.data.list.length;
                        res.data.list = res.data.list.sort((a, b) => a.addtime > b.addtime ? -1 : 1);
                        res.data.list.forEach(function(index,i){
                            index.addtimeStr = new Date(index.addtime * 1000).toLocaleString().replaceAll("/", "-");
                            index.addtime=this.GLOBAL.request.toTime(index.addtime * 1000,2);
                            if(index.id==$typr){
                                index.active=true;
                            }else{
                                index.active=false;
                            }
                            let obj={
                                counttime:index.addtime,
                                countnum:index.score
                            };
                            this.chartData.rows.push(obj);
                            index.timelength=index.timelength>60?parseInt(index.timelength / 60)+'分':index.timelength+'秒'
                        }.bind(this));
                        this.listData = res.data.list;
                        if($typr){
                            this.testId=$typr
                        }else{
                            this.testId=res.data.list[0].id;
                            res.data.list[0].active=true;
                        }
                      let _height=0;
                      let that=this;
                      res.data.errorCount.forEach(function(index,i){
                        _height=0;
                        let _len=index.item.length;
                        index.item.forEach(function(index,i){
                          index.stepHeight=50 * index.errorInfo.length;
                          _height+=index.stepHeight +  0.5;
                          if(index.comments){
                            index.comments.forEach(function(index,i){
                              if(isInArray(that.stepData,index)){

                              }else{
                                that.stepData.push(index);
                              }
                            });
                          }
                        });
                        index.nameHeight=_height;
                      });
                      this.getOneTestInfo(res.data.list[0].id);
                      this.data=res.data.errorCount;
                      if(this.data.name){
                        this.testName=this.data.name;
                      }
                    }
                });
            },
            getOneTestInfo($id){
              oneInfo({test_id:$id}).then((res)=>{
                if(res.code == 200){
                  this.oneData = res.data;
                  let that = this,_height='';
                  res.data.steps.forEach(function(index,i){
                    _height=0;
                    // debugger;
                    let _len=index.itemStep.length;
                    index.itemStep.forEach(function(index,i){
                      index.stepHeight=50;
                      _height+=index.stepHeight +  0.5;
                    });
                    index.nameHeight=_height;
                  });
                }
              });
              this.listData.forEach((index,i)=>{
                if(index.id==$id){
                  index.active=true;
                }else{
                  index.active=false;
                }
              })
            }
        },
        mounted(){
          this.courseId = this.$route.query.plan;
            this.getData();

        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/StoreExamStatistics.vue